export const colors = {
  primary: "#015794", // muni blue
  secondary: "#C5064E", // muni red
  tertiary: "gray",
  quaternary: "#e99c34", // sfmta orange
};

export const mapColors = {
  existing: "#005b95", // sfmta blue
  NB_Only: "#bf2b45", // sfmta red
  SB_Only: colors.quaternary, // sfmta orange
  Converging_Diverging: "#619eb7", // sfmta light blue
  Converging_Diverging_Short: "#683737", // sfmta purple/brown
};

export enum HeaderIds {
  aboutHeader = "aboutHeader",
  whatWeStudiedHeader = "whatWeStudiedHeader",
  whatWeMeasuredHeader = "whatWeMeasuredHeader",
  whatWeLearnedHeader = "whatWeLearnedHeader",
  circulationHeader = "circulationHeader",
  exampleTripsHeader = "exampleTripsHeader",
  testYourOwnRouteHeader = "testYourOwnRouteHeader",
  whatsNextHeader = "whatsNextHeader",
}
